import React, { useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import { NavigationUtils } from 'lib/navigationUtilities';
import { AuthContext } from 'components/user/AuthContext';
import { ContextMenu } from 'components/element/ContextMenu';
import Avatar from 'components/user/Avatar';
import api from 'lib/api';

const HeaderSignedIn = ({ onLogout }) => {
  const { user } = useContext(AuthContext);
  const { navigateToLocation } = NavigationUtils();

  const logoutMutation = useMutation({
    mutationFn: api.auth.logout,
    onSuccess: () => {
      onLogout();
    },
    onError: (error) => {
      console.error('Logout error:', error);
      onLogout();
    }
  });

  return (
    <div className="flex items-center gap-3 mt-[5px]">
      <span className="text-sm font-medium text-gray-strongest truncate max-w-[100px] md:max-w-[250px]">{user.name}</span>
      <ContextMenu trigger={<Avatar src={user.avatar} alt={user.name} />} align="right" >
        <ContextMenu.Item icon={<i className="fas fa-user" />} onClick={() => navigateToLocation(`/${user.username}`)}>
          Profile
        </ContextMenu.Item>
        <ContextMenu.Item icon={<i className="fas fa-cog" />} onClick={() => console.log('Navigate to settings')} disabled>
          Settings
        </ContextMenu.Item>
        <ContextMenu.Separator />
        <ContextMenu.Item
          icon={logoutMutation.isPending
            ? <i className="fas fa-gear fa-spin" />
            : <i className="fas fa-sign-out-alt" />
          }
          onClick={() => logoutMutation.mutate()}
          disabled={logoutMutation.isPending}
        >
          Log Out
        </ContextMenu.Item>
      </ContextMenu>
    </div>
  );
};

export default HeaderSignedIn;
